import createApp, { actions } from '@haravan/app-sdk';

const haravanClientId =
  import.meta.env.VITE_HARAVAN_CLIENT_ID || '72f4e720b1f754fd76e59adac8eb626d';
const haravanShopStorageKey = 'dada-haravan-shop-origin';

export function isHaravanEmbeddedContext(): boolean {
  const params = new URLSearchParams(window.location.search);
  return (
    window.top !== window.self ||
    params.has('shop') ||
    params.has('shopOrigin') ||
    params.has('shop_domain') ||
    params.has('myharavan_domain') ||
    params.has('orgid') ||
    Boolean(readReferrerShopOrigin()) ||
    Boolean(readStoredShopOrigin())
  );
}

export function getHaravanShopOrigin(): string {
  return getShopOrigin();
}

export async function getHaravanSessionToken(): Promise<string> {
  const shopOrigin = getShopOrigin();
  if (!shopOrigin) throw new Error('Missing Haravan shop origin.');

  const app = createApp({
    apiKey: haravanClientId,
    shopOrigin,
    embedded: true,
  });

  return actions.SessionToken.getSessionToken(app);
}

function getShopOrigin(): string {
  const params = new URLSearchParams(window.location.search);
  const shop =
    normalizeShop(params.get('shop')) ||
    normalizeShop(params.get('shopOrigin')) ||
    normalizeShop(params.get('shop_domain')) ||
    normalizeShop(params.get('myharavan_domain')) ||
    readReferrerShopOrigin();
  if (shop) {
    storeShopOrigin(shop);
    return shop;
  }

  return readStoredShopOrigin();
}

function normalizeShop(value: string | null): string {
  return (value || '')
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .replace(/\/.*$/, '');
}

function storeShopOrigin(shop: string): void {
  try {
    localStorage.setItem(haravanShopStorageKey, shop);
  } catch {
    // Storage can be unavailable inside strict embedded browsers.
  }
}

function readStoredShopOrigin(): string {
  try {
    return localStorage.getItem(haravanShopStorageKey) || '';
  } catch {
    return '';
  }
}

function readReferrerShopOrigin(): string {
  try {
    const hostname = new URL(document.referrer).hostname;
    return hostname.endsWith('.myharavan.com') ? normalizeShop(hostname) : '';
  } catch {
    return '';
  }
}
